import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import lydionLogoSmall from 'assets/img/lydionLogoSmall.png';
import lydionLogoSmallDark from 'assets/img/lydionLogoSmallDark.png';

import './PoweredBy.scss';

export interface PoweredByProps {
  variant?: 'dark' | 'light';
}

const PoweredBy: FC<PoweredByProps> = ({ variant = 'light' }) => {
  const { t } = useTranslation();
  const logo = variant === 'dark' ? lydionLogoSmallDark : lydionLogoSmall;

  return (
    <div className={`enkrateia-powered-by ${variant}`}>
      {t('common.poweredBy')} <img src={logo} alt={t('common.lydionLogo') as string} />
    </div>
  );
};

export default PoweredBy;
